var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar"},[_vm._l((_vm.items),function(item,index){return [_c('div',{key:index,staticClass:"nav-item",class:_vm.selected_index === index ? 'nav-item-selected' : '',attrs:{"data-index":index},domProps:{"textContent":_vm._s(item.name)},on:{"click":function($event){_vm.changeIndexDirect(index)}}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48430f1b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBarComponent.vue
// module id = null
// module chunks = 